<template>
  <div class="d-flex flex-column py-5">
    <div class="d-flex justify-space-between">
      <div class="d-block text-h8 black--text font-weight-bold mt-4">Informasi Toko Anda</div>
      <div class="d-block subtitle-1 red--text mr-4 mt-4 cursor-pointer text-right" v-if="userData" @click="copyme">
        <span>
          <span class="pl-1">Bagikan Tautan Toko</span>
          <input type="hidden" :value="getUrlReferal()" id="inputCopy">
        </span>
      </div>
    </div>
    <v-layout v-resize="onResize" column>
      <v-row v-if="profile">
        <v-col cols="12" sm="4">
          <v-card
            class="my-4"
          >
            <template v-if="loadingProcess">
              <v-skeleton-loader
                class="mx-auto"
                height="200"
                type="image"
              ></v-skeleton-loader>
            </template>
            <template v-else>
              <v-img
                height="200"
                :loading="loading"
                calss="border"
                :src="(stores_image) ? stores_image : '/assets/icons/default-toko.jpg'"
              ></v-img>
              <div class="text-caption pa-3 my-2">
                Format gambar .jpg .jpeg .png dan ukuran minimum 300 x 300 px (Untuk gambar optimal gunakan minimum 700 x 700 px)
              </div>
            </template>

            <v-card-text>
              <v-file-input v-show="false" accept="image/*" id="inputImage" v-model="imgUpload" @change="handleFileUpload($event)" truncate-length="50" small-chips outlined dense hide-details="auto" prepend-icon="" :clearable="false" placeholder="GANTI FOTO" class="mt-md-3 text-body-2 rounded-lg file-button"></v-file-input>
              <v-btn
                color="primary"
                outlined
                block
                :loading="loadingProcess"
                @click="openUpload"
              >
                <strong>Ganti Gambar Toko</strong>
              </v-btn>
            </v-card-text>
            <v-divider class="mx-4"></v-divider>

            <v-card-text>
              <v-card>
                <v-card-subtitle class="pb-2 font-weight-bold d-flex align-center justify-space-between">
                  Status Toko
                  
                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-width="200"
                    :max-width="400"
                    offset-x
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        text
                        small
                        dense
                        icon
                        class="px-1"
                        color="grey darken-1"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        style="min-width: auto;"
                      >
                        <v-icon>mdi-help-circle</v-icon>
                      </v-btn>
                    </template>

                    <v-card elevation="0" outlined>
                      <v-card-text class="pa-5 d-flex flex-row align-start">
                        <v-icon dense x-large class="mr-4">mdi-help-circle-outline</v-icon>
                        <p class="mb-0">Jika mode Status Toko tidak aktif (tutup), maka toko Anda tidak dapat melayani penjualan produk Anda.</p>
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </v-card-subtitle>
                
                <v-card-text>
                  <hr>
                  <div class="d-flex flex-row align-center justify-space-between">
                    <v-switch
                      v-model="store.isOpen"
                      dense
                      inset
                      hide-details="auto"
                      @change="updateStatusStore"
                    ></v-switch>

                    <span class="font-weight-bold mt-4" :class="(storeIsOpen == 'Buka') ? 'primary--text' : ''">Toko {{ storeIsOpen }}</span>
                  </div>
                </v-card-text>
              </v-card>
            </v-card-text>

            <v-card-text>
              <v-card>
                <v-card-subtitle class="pb-2 font-weight-bold d-flex align-center justify-space-between">
                  Aktifkan Mode Seller
                  
                  <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-width="200"
                    :max-width="400"
                    offset-x
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        text
                        small
                        dense
                        icon
                        class="px-1"
                        color="grey darken-1"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        style="min-width: auto;"
                      >
                        <v-icon>mdi-help-circle</v-icon>
                      </v-btn>
                    </template>

                    <v-card elevation="0" outlined>
                      <v-card-text class="pa-5 d-flex flex-row align-start">
                        <v-icon dense x-large class="mr-4">mdi-help-circle-outline</v-icon>
                        <p class="mb-0">Jika Anda mengaktifkan mode Seller, maka Anda dapat menjual produk dengan stok produk Anda sendiri.</p>
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </v-card-subtitle>
                <v-card-text>
                  <hr>
                  <div class="d-flex flex-row align-center justify-space-between">
                    <v-switch
                      v-model="store.isSeller"
                      dense
                      inset
                      hide-details="auto"
                      :disabled="(!store.isDropshipper && detailStore.store_is_dropship == 'Tidak') ? true : false"
                      @change="updateSellerMode"
                    ></v-switch>

                    <span class="font-weight-bold mt-4" :class="(storeIsSeller == 'Ya') ? 'primary--text' : ''">{{ (storeIsSeller == 'Ya') ? 'Aktif' : 'Tidak Aktif' }}</span>
                  </div>
                </v-card-text>
              </v-card>
            </v-card-text>

            <v-card-text v-if="detailStore.store_is_dropship == 'Tidak'">
              <v-card>
                <v-card-subtitle class="pb-2 font-weight-bold d-flex align-center justify-space-between">
                  Aktifkan Mode Dropshipper
                  
                  <v-menu
                    v-model="menuDropshipper"
                    :close-on-content-click="false"
                    :nudge-width="200"
                    :max-width="400"
                    offset-x
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        text
                        small
                        dense
                        icon
                        class="px-1"
                        color="grey darken-1"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        style="min-width: auto;"
                      >
                        <v-icon>mdi-help-circle</v-icon>
                      </v-btn>
                    </template>

                    <v-card elevation="0" outlined>
                      <v-card-text class="pa-5 d-flex flex-row align-start">
                        <v-icon dense x-large class="mr-4">mdi-help-circle-outline</v-icon>
                        <p class="mb-0">Jika Anda mengaktifkan mode Dropshipper, toko Anda dapat meneruskan pesanan kepada Stockist Dropship yang telah bekerja sama dengan toko Anda.</p>
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </v-card-subtitle>
                <v-card-text>
                  <hr>
                  <div class="d-flex flex-row align-center justify-space-between">
                    <v-switch
                      v-model="store.isDropshipper"
                      dense
                      inset
                      hide-details="auto"
                      :disabled="(!store.isSeller) ? true : false"
                      @change="updateDropshipperMode"
                    ></v-switch>

                    <span class="font-weight-bold mt-4" :class="(store.isDropshipper) ? 'primary--text' : ''">{{ (store.isDropshipper) ? 'Aktif' : 'Tidak Aktif' }}</span>
                  </div>
                </v-card-text>
              </v-card>
            </v-card-text>

            <v-card-text v-if="detailStore.store_is_seller == 'Ya'">
              <v-card>
                <v-card-subtitle class="pb-2 font-weight-bold d-flex align-center justify-space-between">
                  Aktifkan Free Ongkir Pesanan
                  
                  <v-menu
                    v-model="menuFreeOngkir"
                    :close-on-content-click="false"
                    :nudge-width="200"
                    :max-width="400"
                    offset-x
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        text
                        small
                        dense
                        icon
                        class="px-1"
                        color="grey darken-1"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        style="min-width: auto;"
                      >
                        <v-icon>mdi-help-circle</v-icon>
                      </v-btn>
                    </template>

                    <v-card elevation="0" outlined>
                      <v-card-text class="pa-5 d-flex flex-row align-start">
                        <v-icon dense x-large class="mr-4">mdi-help-circle-outline</v-icon>
                        <p class="mb-0">Jika Anda mengaktifkan Free Ongkir Pesanan, setiap pesanan yang Anda terima, pembeli tidak akan dikenakan biaya ongkos kirim.</p>
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </v-card-subtitle>
                <v-card-text>
                  <hr>
                  <div class="d-flex flex-row align-center justify-space-between">
                    <v-switch
                      v-model="store.isFreeOngkir"
                      dense
                      inset
                      hide-details="auto"
                      @change="updateFreeOngkirMode"
                    ></v-switch>

                    <span class="font-weight-bold mt-4" :class="(store.isFreeOngkir) ? 'primary--text' : ''">{{ (store.isFreeOngkir) ? 'Aktif' : 'Tidak Aktif' }}</span>
                  </div>
                </v-card-text>
              </v-card>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="8" :class="{'px-7': !isMobile}">
          <!-- statistik toko -->
          <v-card
            class="mx-0"
            :class="{'my-4': !isMobile}"
            flat
            v-if="false"
          >
            <v-card-text class="px-0 py-0">
              <v-row>
                <v-col cols="12" sm="4" class="pt-0">
                  <v-card>
                    <v-card-title class="d-block text-center text-subtitle-2 black--text">Produk</v-card-title>
                    <v-divider class="mx-0"></v-divider>
                    <v-card-text>
                      <!-- <div class="d-block text-h4 green--text text-center">{{ profile.store_stock.length }}</div> -->
                      <div class="d-block text-h4 primary--text text-center">0</div>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="4" class="pt-0">
                  <v-card>
                    <v-card-title class="d-block text-center text-subtitle-2 black--text">Penjualan</v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                      <!-- <div class="d-block text-h4 green--text text-center">{{ profile.store_trx_count }}</div> -->
                      <div class="d-block text-h4 primary--text text-center">0</div>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="4" class="pt-0">
                  <v-card>
                    <v-card-title class="d-block text-center text-subtitle-2 black--text">Pembelian</v-card-title>
                    <v-divider class="mx-4"></v-divider>
                    <v-card-text>
                      <!-- <div class="d-block text-h4 green--text text-center">{{ profile.store_po_count }}</div> -->
                      <div class="d-block text-h4 primary--text text-center">0</div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- profile toko -->
          <v-card
            class="my-4"
          >
            <v-card-title class="text-subtitle-1 font-weight-bold">
              <v-row>
                <v-col cols="12" sm="6" class="py-0">
                  Profil Toko Anda
                </v-col>
                <v-col  cols="12" sm="6" :class="{'py-0 text-right': !isMobile}">
                  <!-- <v-btn
                    small
                    text
                    elevation="0"
                    class="text-capitalize"
                    :class="{'v-btn--outlined v-btn--block v-size--default': isMobile}"
                    @click="openModule('/seller/rekening-bank')"
                  >
                    <v-icon class="mr-2 grey--text">mdi-cog-outline</v-icon> Pengaturan
                  </v-btn> -->
                </v-col>
              </v-row>
            </v-card-title>
            <v-divider class="mx-4"></v-divider>
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="12" class="d-flex flex-row align-start justify-space-between pt-0">
                  <div class="subtitle-1">Nama Toko</div>
                  <div class="primary--text">{{ profile.store_name | emptyData }}</div>
                </v-col>
                <v-col cols="12" sm="12" class="d-flex flex-row align-start justify-space-between pt-0">
                  <div class="subtitle-1">Telepon</div>
                  <div class="primary--text">{{ profile.store_phone | emptyData }}</div>
                </v-col>

                <v-col cols="12" sm="12" class="d-flex flex-row align-start justify-space-between pt-0">
                  <div class="subtitle-1">Status Toko</div>
                  <div class="primary--text" v-if="profile.store_open_status == 'Buka'">
                    <v-chip
                      text-color="#fff"
                      color="success"
                      small
                      class="px-4 font-weight-bold"
                      >{{ profile.store_open_status }}
                    </v-chip>
                  </div>
                  <div class="primary--text" v-else>
                    <v-chip
                      text-color="#fff"
                      color="error"
                      small
                      class="px-4 font-weight-bold"
                      >{{ profile.store_open_status }}
                    </v-chip>
                  </div>
                </v-col>
                <v-col cols="12" sm="12" class="d-flex flex-row align-start justify-space-between pt-0">
                  <div class="subtitle-1">Alamat</div>
                  <div class="primary--text text-right" style="width: 60%;">{{ addressText(profile) }}</div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- banner  -->
          <v-card
            class="my-4"
            v-if="false"
          >
            <v-card-title class="text-subtitle-1 font-weight-bold">
              <v-row>
                <v-col cols="12" sm="6" class="py-0">
                  Banner Toko
                </v-col>
                <v-col  cols="12" sm="6" :class="{'py-0 text-right': !isMobile}">
                  <!-- <v-btn
                    small
                    text
                    elevation="0"
                    class="text-capitalize"
                    :class="{'v-btn--outlined v-btn--block v-size--default': isMobile}"
                    @click="openModule('/seller/rekening-bank')"
                  >
                    <v-icon class="mr-2 grey--text">mdi-cog-outline</v-icon> Pengaturan
                  </v-btn> -->
                </v-col>
              </v-row>
            </v-card-title>
            <v-divider class="mx-4"></v-divider>
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="12" class="d-flex flex-column py-0">
                  <v-img
                    height="200"
                    :loading="loading"
                    calss="border"
                    :src="(profile.store_banner_image) ? profile.store_banner_image : '/assets/icons/banner_default.jpg'"
                  ></v-img>
                  <div class="text-caption text-center px-3 mt-2">
                    Format gambar .jpg .jpeg .png dan ukuran optimal 1140 x 600 px
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- setting alamat default -->
          <v-card
            class="my-4"
          >
            <v-card-title class="text-subtitle-1 font-weight-bold" :loading="loadOrigin">
              <v-row>
                <v-col cols="12" sm="12" class="py-0">
                  Alamat Asal Pengiriman
                </v-col>
              </v-row>
            </v-card-title>
            <v-divider class="mx-4"></v-divider>
            <v-card-text v-if="!loadOrigin">
              <v-row align="stretch" v-if="Object.keys(defaultOrigin).length > 0">
                <v-col cols="12" sm="6" class="d-flex flex-row align-center justify-space-between pt-0" v-if="defaultOrigin.Seller !== undefined">
                  <v-card outlined rounded elevation="0" style="width: 100%; height: 100%;" class="cardOrigin" :class="{ isCardActive: cardOrigin === 0}" @click="updateDefaultOrigin('Seller')">
                    <v-card-text class="pa-4">
                      <label v-bind:class="{ isActive: cardOrigin === 0}" class="d-flex flex-row align-start">
                        <input type="radio" dense v-model="cardOrigin" value="0" :checked="cardOrigin === 0" class="d-none" />
                        <v-icon v-if="cardOrigin == 0" color="#16848A">mdi-checkbox-marked-circle</v-icon>
                        <v-icon v-else color="#ddd">mdi-checkbox-blank-circle-outline</v-icon>
                        <span class="text pl-4 pt-50">
                          <strong class="originTitle d-block mb-2">Alamat Toko</strong>
                          <strong class="d-block mb-2 black--text">{{ defaultOrigin.Seller.store_name }}</strong>
                          {{ addressOriginText(defaultOrigin.Seller) }}
                        </span>
                      </label>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="6" class="d-flex flex-row align-center justify-space-between pt-0" v-if="defaultOrigin.Dropshipper !== undefined && store.isDropshipper">
                  <v-card outlined rounded elevation="0" style="width: 100%; height: 100%;" class="cardOrigin" :class="{ isCardActive: cardOrigin === 1}" @click="updateDefaultOrigin('Dropship')">
                    <v-card-text class="pa-4">
                      <label v-bind:class="{ isActive: cardOrigin === 1}" class="d-flex flex-row align-start">
                        <input type="radio" dense v-model="cardOrigin" value="0" :checked="cardOrigin === 0" class="d-none" />
                        <v-icon v-if="cardOrigin == 1" color="#16848A">mdi-checkbox-marked-circle</v-icon>
                        <v-icon v-else color="#ddd">mdi-checkbox-blank-circle-outline</v-icon>
                        <span class="text pl-4 pt-50">
                          <strong class="originTitle d-block mb-2">Alamat Dropship</strong>
                          <strong class="d-block mb-2 black--text">{{ defaultOrigin.Dropshipper.store_name }}</strong>
                          {{ addressOriginText(defaultOrigin.Dropshipper) }}
                        </span>
                      </label>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>

              <v-row align="stretch" v-else>
                <v-col cols="12" sm="6" class="d-flex flex-row align-center justify-space-between pt-0">
                  <p class="text-caption">Belum ada alamat asal pengiriman yang tersedia.</p>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-text v-else>
              <v-row>
                <v-col cols="12" sm="6">
                  <v-sheet
                    :color="`grey lighten-4`"
                    class="pa-3"
                  >
                    <v-skeleton-loader
                      class="mx-auto"
                      max-height="160"
                      type="card"
                    ></v-skeleton-loader>
                  </v-sheet>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-sheet
                    :color="`grey lighten-4`"
                    class="pa-3"
                  >
                    <v-skeleton-loader
                      class="mx-auto"
                      max-height="160"
                      type="card"
                    ></v-skeleton-loader>
                  </v-sheet>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- info rekening bank -->
          <v-card
            class="my-4"
          >
            <v-card-title class="text-subtitle-1 font-weight-bold">
              <v-row>
                <v-col cols="12" sm="6" class="py-0">
                  Rekening Bank
                </v-col>
                <v-col  cols="12" sm="6" :class="{'py-0 text-right': !isMobile}">
                  <!-- <v-btn
                    small
                    text
                    elevation="0"
                    class="text-capitalize"
                    :class="{'v-btn--outlined v-btn--block v-size--default': isMobile}"
                    @click="openModule('/seller/rekening-bank')"
                  >
                    <v-icon class="mr-2 grey--text">mdi-cog-outline</v-icon> Pengaturan
                  </v-btn> -->
                </v-col>
              </v-row>
            </v-card-title>
            <v-divider class="mx-4"></v-divider>
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="4" class="d-flex align-start pt-0">
                  <div class="primary--text">
                    <v-img width="160" contain :src="profile.bank_image" :alt="profile.store_bank_name"></v-img>
                  </div>
                </v-col>
                <v-col cols="12" sm="8" class="d-flex flex-column align-start pt-0">
                  <div class="black--text font-weight-bold font-size-16">{{ profile.store_bank_account_number | emptyData }}</div>
                  <div class="dark--text font-weight-bold">{{ profile.store_bank_account_name | emptyData }}</div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- info kurir -->
          <v-card
            class="my-4"
          >
            <v-card-title class="text-subtitle-1 font-weight-bold">
              <v-row>
                <v-col cols="12" sm="6" class="py-0">
                  Kurir Pengiriman
                </v-col>
                <v-col cols="12" sm="6" class="text-right" :class="{'py-0': !isMobile}">
                  <v-btn
                    small
                    text
                    elevation="0"
                    class="text-capitalize"
                    :class="{'v-btn--outlined v-btn--block v-size--default': isMobile}"
                    @click="openModule('/seller/pengaturan-pengiriman')"
                  >
                    <v-icon class="mr-2 grey--text">mdi-cog-outline</v-icon> Pengaturan
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-title>
            <v-divider class="mx-4"></v-divider>
            <v-card-text>
              <v-row>
                <template v-for="(kurir, idx) in storeCourier">
                  <v-col cols="6" sm="4" class="d-flex align-center" :key="idx" v-if="kurir.value !== 'Tiki'">
                    <div class="d-flex flex-column align-center justify-center" style="width: 100%;">
                      <!-- <div class="subtitle-1 text-uppercase mb-2">{{ kurir.label }}</div> -->
                      <v-img
                        width="100%"
                        max-width="100%"
                        cover
                        :src="kurir.image"
                      ></v-img>
                    </div>
                  </v-col>
                </template>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-layout>

  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import moment from 'moment'

const defaultInput = () => ({
  company_name: '',
  store_name: '',
  store_mobilephone: '',
  store_address: '',
  store_courier: [],
  permission: [],
  image: [],
  note: '',
})


export default {
  props: ['profile'],
  data() {
    return {
      loading: false,
      loadingProcess: false,
      loadOrigin: false,
      isMobile: false,
      imgUpload: {},
      stores_image: '',
      listPermission: ['BPOM', 'MUI', 'Dll'],
      dialogB2b: false,
      paramsB2b: defaultInput(),
      imgPreview: [],
      onEdit: false,
      store_description: '',
      menu: false,
      menu2: false,
      menuDropshipper: false,
      menuFreeOngkir: false,
      defaultPartner: {},
      cardOrigin: null,
      store: {
        isOpen: 0,
        isSeller: false,
        isDropshipper: false,
        isFreeOngkir: false
      },
      descriptionRules: [
        v => !!v || 'Nama Toko tidak boleh kosong',
        v => v.length <= 50 || 'Deskripsi maksimal 50 karakter',
      ],
      rulesB2b: {
        company_name: [
          v => !!v || 'Nama Perusahaan tidak boleh kosong',
        ],
        store_name: [
          v => !!v || 'Nama Toko tidak boleh kosong',
        ],
        store_mobilephone: [
          v => !!v || 'Nomor Handphone tidak boleh kosong',
        ],
        store_address: [
          v => !!v || 'Alamat Toko tidak boleh kosong',
        ],
        store_courier: [
          v => v.length > 0 || 'Kurir tidak boleh kosong',
        ],
        permission: [
          v => v.length > 0 || 'Izin tidak boleh kosong',
        ],
        image: [
          v => !!v || 'Gambar tidak boleh kosong',
        ],
      }
    }
  },

  computed: {
    ...mapState('auth', ['userData']),
    ...mapState('storeSeller', ['detailStore', 'storeCourier', 'storeIsOpen', 'storeIsSeller', 'storeIsDropshipper', 'storeIsFreeOngkir', 'defaultOrigin', 'response']),
    ...mapState('options', ['courier']),
    ...mapState('authSeller', ['isAuth', 'sellerData']),
    ...mapState('partnersSeller', ['partnersDropship']),
  },

  watch: {
    storeIsOpen(val) {
      this.store.isOpen = (val == 'Buka') ? true : false
    },

    storeIsSeller(val) {
      this.store.isSeller = (val == 'Ya') ? true : false
      this.loadDefaultOriginData()
      if (val == 'Tidak' && Object.keys(this.defaultOrigin.Dropshipper).length > 0) this.updateDefaultOrigin('Dropship') 
    },
    
    storeIsDropshipper(val) {
      this.store.isDropshipper = (val == 'Ya') ? true : false
      this.loadDefaultOriginData()
      if (val == 'Tidak') this.updateDefaultOrigin('Seller') 
    },

    storeIsFreeOngkir(val) {
      this.store.isFreeOngkir = (val == 'Tidak') ? false : true
    },
  },

  methods: {
    ...mapActions('storeSeller', ['getStoreDetail', 'updateStoreImage', 'getStoreCourier', 'saveDescription', 'updateStoreOpen', 'updateStoreClose', 'updateStoreType', 'updateDropshipperType', 'getStoreDefaultOrigin', 'setStoreDefaultOrigin', 'updateFreeOngkirStore']),
    ...mapActions('partnersSeller', ['getPartnershipList']),
    ...mapActions('options', ['getCourier']),
    ...mapMutations(['makeAlert']),

    updateStatusStore() {
      this.loading = true
      if (this.storeIsOpen == 'Buka') {
        this.updateStoreClose().then(() => {
          this.getStoreDetail()
          // this.store.isOpen = this.storeIsOpen
          setTimeout(() => {
            this.loading = false
          }, 1000);
        }).catch(() => {
          this.store.isOpen = !this.store.isOpen
          this.loading = false
        })
      } else {
        this.updateStoreOpen().then(() => {
          this.getStoreDetail()
          // this.store.isOpen = this.storeIsOpen
          setTimeout(() => {
            this.loading = false
          }, 1000);
        }).catch(() => {
          this.store.isOpen = !this.store.isOpen
          this.loading = false
        })
      }
    },

    updateSellerMode() {
      this.loading = true
      const mode = (this.store.isSeller) ? 'Ya' : 'Tidak'
      this.updateStoreType({store_is_seller: mode}).then(() => {
        this.getStoreDetail()
        setTimeout(() => {
          this.loading = false
        }, 1000);
      })
      .catch(() => {
        this.store.isSeller = !this.store.isSeller
      })
    },

    updateDropshipperMode() {
      this.loading = true
      const mode = (this.store.isDropshipper) ? 'Ya' : 'Tidak'
      this.updateDropshipperType({store_is_dropshipper: mode}).then(() => {
        this.getStoreDetail()
        setTimeout(() => {
          this.loading = false
        }, 1000);
      })
      .catch(() => {
        this.store.isDropshipper = !this.store.isDropshipper
      })
    },

    updateFreeOngkirMode() {
      this.loading = true
      const mode = (this.store.isFreeOngkir) ? 'Ya' : 'Tidak'
      this.updateFreeOngkirStore({store_free_delivery: mode}).then(() => {
        this.getStoreDetail()
        setTimeout(() => {
          this.loading = false
        }, 1000);
      })
      .catch(() => {
        this.store.isFreeOngkir = !this.store.isFreeOngkir
      })
    },

    async updateDefaultOrigin(type) {
      this.loadOrigin = await true
      this.setStoreDefaultOrigin({store_default_shipping_origin: type}).then(() => {
        this.getStoreDefaultOrigin()
        setTimeout(() => {
          if (this.defaultOrigin.Seller !== undefined && this.defaultOrigin.Seller.is_default) this.cardOrigin = 0
          else if (this.defaultOrigin.Dropshipper !== undefined && this.defaultOrigin.Dropshipper.is_default) this.cardOrigin = 1
          this.loadOrigin = false
        }, 1000);
      })
      .catch(() => {
        this.loadOrigin = false
        // this.store.isDropshipper = !this.store.isDropshipper
      })
    },

    async loadDefaultOriginData() {
      this.loadOrigin = await true
      this.getStoreDefaultOrigin()
      setTimeout(() => {
        if (this.defaultOrigin.Seller !== undefined && this.defaultOrigin.Seller.is_default) this.cardOrigin = 0
        else if (this.defaultOrigin.Dropshipper !== undefined && this.defaultOrigin.Dropshipper.is_default) this.cardOrigin = 1
        this.loadOrigin = false
      }, 1000);
    },

    async getDefaultPartner() {
      await this.getPartnershipList()
        .then((results) => {
          const partner = results.find(x => x.store_partnership_is_default == true) 
          this.defaultPartner = partner
        })
        .catch(() => {
          this.defaultPartner = {}
        })
    },

    cancelEdit() {
      this.onEdit = false
    },

    async saveEdit() {
      this.loadingProcess = await true
      await this.saveDescription({
        description: this.store_description
      }).then(() => {
        this.getStoreDetail()
        this.onEdit = false
        this.loadingProcess = false
      }).catch(() => {
        this.makeAlert({ code: 'error_response', type: 'error', message: 'Gagal mengubah deskripsi toko', show: true })
        this.loadingProcess = false
      })
    },

    formatDateText(params, format) {
      let dates = (params) ? new Date(params) : null
      return (dates) ? moment(dates).format(format) : null
    },

    addressText(value) {
			var data = []
			if (value.store_address_detail)
				data.push(value.store_address_detail)
			if (value.store_sub_district_name)
				data.push(value.store_sub_district_name)
			if (value.store_district_name)
				data.push(value.store_district_name)
			if (value.store_city_name)
				data.push(value.store_city_name)
			if (value.store_province_name)
				data.push(value.store_province_name)
			return data.join(', ')
		},

    addressOriginText(value) {
			var data = []
			if (value.store_sub_district_name)
				data.push(value.store_sub_district_name)
			if (value.store_district_name)
				data.push(value.store_district_name)
			if (value.store_city_name)
				data.push(value.store_city_name)
			if (value.store_province_name)
				data.push(value.store_province_name)
			return data.join(', ')
		},

    async openUpload() {
      const input = await document.getElementById('inputImage')
      input.click()
    },

    openConfirmB2b() {
      this.canRequestB2b().then(async () => {
        await this.getCourier()
        this.dialogB2b = await true
      })
    },

    confirmationB2b() {
      if (this.$refs.formB2b.validate()) {
        var dimensions = []
        this.imgPreview.forEach((el) => {
          dimensions.push(new Promise( (resolve) => {
            let formData = new FormData();
            formData.append('image', el.file);
            this.updateStoreImageB2b(formData).then((res) => {
              resolve(res.product_image)
            })
          }));
        });

        Promise.all(dimensions).then((dims) => {
          this.paramsB2b.image = dims
          this.requestB2b(this.paramsB2b).then( () => {
            this.getStoreDetail()
            this.$refs.formB2b.resetValidation()
            this.$refs.fileuploadB2b.clearableCallback()
            this.imgPreview = []
            this.paramsB2b = defaultInput()
            this.loadingProcess = false
            this.dialogB2b = false
          })
        }).catch(function(err){
          console.log(err)
          this.loadingProcess = false
        })
      }
    },

    createImage(event) {
      var dimensions = [];
      event.forEach((el) => {
        dimensions.push(new Promise(function (resolve) {

          var reader = new FileReader();
          reader.onload = (e) => {
            resolve({
              img: e.target.result,
              file: el
            })
          };
          reader.readAsDataURL(el);
        }));
      });

      Promise.all(dimensions).then((res) => {
        if (this.imgPreview.length + res.length > 10)
          this.makeAlert({ code: 'error_response', type: 'error', message: 'Gambar maksimal 10', show: true })

        res.splice(10 - this.imgPreview.length, res.length - 1)
        this.imgPreview = [...new Set([...this.imgPreview, ...res])]

      }).catch(function(err) {
        console.log(err)
      })
    },

    handleFileUpload(event) {
      this.loadingProcess = true
      let formData = new FormData();
      formData.append('store_image', event);
      this.updateStoreImage(formData)
      .then(() => {
        this.getStoreDetail().then(() => {
          this.stores_image = (this.detailStore) ? this.detailStore.store_image : null
        })
        this.makeAlert({ code: 'success', type: 'success', message: this.response.message, show: true })
        this.imgUpload = {}

        setTimeout(() => {
          this.loadingProcess = false
        }, 1000);
      })
      .catch(() => {
        this.imgUpload = {}
        this.loadingProcess = false
      })
    },

    openModule(link) {
      this.$router.push({ path : link})
    },

    onResize() {
      if (window.innerWidth < 769)
        this.isMobile = true;
      else
        this.isMobile = false;
    },

    getUrlReferal() {
      if (this.detailStore && Object.keys(this.detailStore).length > 0) {
        let link = `${window.origin}/store/${this.detailStore.store_slug}`
        if (this.userData.user_network_id > 0) {
          link += `/${this.userData.user_mobilephone}`
        }
        return link
      }
    },

    copyme() {
      var copyText = document.getElementById("inputCopy")
      copyText.setAttribute('type', 'text')
      copyText.select()
      try {
        document.execCommand('copy');
        setTimeout(() => {
          this.$store.commit('makeAlert', { code: 'success', type: 'success', message: 'Tautan berhasil disalin', show: true });
        }, 300);
      } catch (err) {
        alert('Oops, tidak dapat menyalin');
      }
      copyText.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },
  },

  async created() {
    this.$store.dispatch('setPageTitle', `Profil Seller`);
    this.loading = await true
    await this.getStoreCourier()
    await this.getStoreDefaultOrigin()

    if (this.defaultOrigin.Seller !== undefined && this.defaultOrigin.Seller.is_default) this.cardOrigin = 0
    else if (this.defaultOrigin.Dropshipper !== undefined && this.defaultOrigin.Dropshipper.is_default) this.cardOrigin = 1

    this.getStoreDetail().then(() => {
      this.stores_image = (this.detailStore) ? this.detailStore.store_image : null
      this.store.isOpen = (this.storeIsOpen == 'Buka') ? true : false
      this.store.isSeller = (this.storeIsSeller == 'Ya') ? true : false
      this.store.isDropshipper = (this.storeIsDropshipper == 'Ya') ? true : false
      this.store.isFreeOngkir = (this.storeIsFreeOngkir == 'Ya') ? true : false
    })
    this.loading = false
  },
}
</script>


<style scoped>
  .isCardActive, .cardOrigin.isCardActive:hover {
    border: 2px solid #16848A!important;
    background: #f9f9f9;
  }

  .isCardActive .originTitle {
    color: #16848A;
    font-weight: 800;
    cursor: pointer;
  }

  .cardOrigin {
    border-radius: 8px!important;
    cursor: pointer;
  }

  .cardOrigin .originTitle {
    cursor: pointer;
  }

  .cardOrigin:hover {
    border-color: #B3D234;
  }
</style>